import { ReactNode } from 'react';

import { RadioInput } from 'components/Blocks';
import { cn } from 'styles';

interface ButtonGroupProps<Value extends string> {
  children?: never;
  value: Value | null | undefined;
  onChange: (value: Value) => void;

  options: Array<{
    value: string;
    label: ReactNode;
  }>;

  containerClassName?: string;

  /**
   * Divides each button vertically with a border
   *
   * Defaults to true
   */
  verticalDivisor?: boolean;
}

export function ButtonGroup<Value extends string>({
  onChange,
  value,
  options,
  containerClassName,
  verticalDivisor = true,
}: ButtonGroupProps<Value>) {
  return (
    <RadioInput
      orientation="horizontal"
      onChangeDirect={onChange as () => void}
      value={value || ''}
      className={cn(
        'relative flex flex-shrink-0 items-center justify-center px-3 py-1 hover:bg-hover',
        'first-of-type:rounded-l-full last-of-type:rounded-r-full',
        verticalDivisor ? 'border' : 'border-y border-l last-of-type:border-r',
      )}
      selectedClassName="border-primary text-primary hover:bg-transparent"
      addDot={false}
      gap="0"
      options={options}
      containerClassName={containerClassName}
    />
  );
}
